import Vue from "vue";
import VueRouter from "vue-router";

import Sites from "../components/Donnée de base/Sites.vue";
import Véhicule from "../components/Donnée de base/Véhicule.vue";
import Employe from "../components/Donnée de base/Employe.vue";
import Variété from "../components/Donnée de base/Variété.vue";
import Parcelle from "../components/Donnée de base/Parcelle.vue";

//import LogIn from "../LogIn.vue";
import ListePresence from "../components/PointagePrésence/ListePresence.vue";
import PointageAnalitique from "../components/PointageAnalitique/PointageAnalitique.vue";
import PointageTrans from "../components/PointageTrans/PointageTrans.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "LogIn",
  //   component: LogIn,
  // },
  {
    path: "/",
    name: "Default",
    component: ListePresence,
  },
  {
    path: "/site",
    name: "site",
    component: Sites,
  },
  {
    path: "/Véhicule",
    name: "Véhicule",
    component: Véhicule,
  },
  {
    path: "/Employe",
    name: "Employe",
    component: Employe,
  },
  {
    path: "/Parcelle",
    name: "Parcelle",
    component: Parcelle,
  },
  {
    path: "/Variété",
    name: "Variété",
    component: Variété,
  },

  {
    path: "/PointagePresence",
    name: "PointagePresence",
    component: ListePresence,
  },
  {
    path: "/PointageAnalitique",
    name: "PointageAnalitique",
    component: PointageAnalitique,
  },
  {
    path: "/PointageTrans",
    name: "PointageTrans",
    component: PointageTrans,
  },
  {
    path: "/:notFound(.*)",
    name: "NF",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
